// @architect-approved: INFRASTRUCTURE - App entry point (ReactDOM.createRoot bootstrap), not a registered @tg-seq component — the "Self" component identity pattern does not apply here.

import { LicenseInfo } from '@mui/x-license';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './app/store';
import './index.css';

// ✅ MUI DataGrid Pro License (REQUIRED for grids to render)
// Get your license key from: https://mui.com/store/items/mui-x-pro/
// Cost: $249/year per developer
//
// Option 1: Use environment variable (recommended for production)
// Add to .env: VITE_MUI_LICENSE_KEY=your-key-here
//
// Option 2: Hardcode here (only for testing)
const MUI_LICENSE_KEY = import.meta.env.VITE_MUI_LICENSE_KEY || 'YOUR_LICENSE_KEY_HERE';

// FIX (2026-09-29): .env.local ships the placeholder in lowercase
// ("your-license-key-here"), but this guard only ever checked the uppercase
// sentinel ("YOUR_LICENSE_KEY_HERE") - so the lowercase placeholder passed
// this check as if it were a real key and got handed to
// LicenseInfo.setLicenseKey(), producing an "invalid license" watermark
// instead of the intended "not configured" warning below. Compare
// case-insensitively so ANY casing of the placeholder is caught.
const isPlaceholderKey = /^your[-_]?license[-_]?key/i.test(MUI_LICENSE_KEY);

if (MUI_LICENSE_KEY && !isPlaceholderKey) {
    LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);
} else {
    console.warn('⚠️ MUI DataGrid Pro license not configured. Grids will not render.');
    console.warn('Purchase license: https://mui.com/store/items/mui-x-pro/');
    console.warn('Then set VITE_MUI_LICENSE_KEY in .env or update main.tsx');
}

// Register AG Grid modules globally BEFORE React initialization
// This prevents double-registration in StrictMode
ModuleRegistry.registerModules([AllCommunityModule]);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
);
